// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"332a4a9e","837":"ede0f7b6","897":"364f18dc"}[chunkId] + ".chunk.js";
};